<template>
<div class="leftListTab">
  <div class="searchBox">
    <div class="search">
      <el-input
          v-model="search.key"
          @input="handleSearch"
          placeholder="请输入内容">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <div class="deliveringBtn" @click="addPatient()"><span>+</span>接诊</div>
    <!-- <div class="deliveringBtnNot" @click="addPatient()"><span>+</span>接诊</div> -->
  </div>
  <div class="listTabBox">
    <div class="tabBox">
      <div class="tabItem">
        门诊 <span>{{patientList.length}}</span>
      </div>
    </div>
    <div class="select">
      <div class="dateLabel" @click="showDatePicker = true">{{dateLabel}}<i class="el-icon-caret-bottom"></i></div>
      <div class="pickerBox">
        <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="search.date"
            type="date"
            :picker-options="{disabledDate: (time) => time.getTime() > Date.now()}"
            @change="handleDateChange"
            placeholder=""
            v-show="showDatePicker"
            @close="showDatePicker = false"
            ref="datePickerRef">
        </el-date-picker>
      </div>

    </div>
  </div>
  <div class="listBox">

    <div :class="active === item.draftId ?'itemBoxActive':'itemBox'" @click="activeItem(item,'view')" v-for="item in $store.state.patientDraftList" :key="item.key" v-if="$store.state.patientDraftList && $store.state.patientDraftList.length !== 0 && search.key === '' && search.date == formatDate(new Date())">
      <div class="userInfo">
        <div class="userImg">
          <i class="el-icon-user-solid"></i>
        </div>
        <div class="userName">{{item.name}}</div>
      </div>
      <div class="caseSequence" v-if="getNoonValue() === '01'">上午</div>
      <div class="caseSequence" v-if="getNoonValue() === '03'">下午</div>
      <div class="caseSequence" v-if="getNoonValue() === '05'">晚上</div>
      <div class="statusLabel" v-if="item.visitState === '00'">草稿</div>
      <div class="statusLabel" style="color: #1e88f6;font-weight: 400" v-if="item.visitState === '01'">待诊</div>
      <div class="statusLabel" style="color: #aab4bf;font-weight: 400" v-if="item.visitState === '02'">已诊</div>
      <div class="statusLabel" style="color: #aab4bf;font-weight: 400" v-if="item.visitState === '03'">已收</div>
      <div class="statusLabel" style="color: #aab4bf;font-weight: 400" v-if="item.visitState === '04'">已退</div>
    </div>
    <div :class="active === item.medicalRecordId ?'itemBoxActive':'itemBox'" @click="activeItem(item,'view')" v-for="item in patientList" :key="item.medicalRecordId" v-if="patientList.length !== 0">
      <div class="userInfo">
        <div class="userImg">
          <i class="el-icon-user-solid"></i>
        </div>
        <div class="userName">{{item.name}}</div>
      </div>
      <div class="caseSequence" v-if="item.noon === '01'">上午</div>
      <div class="caseSequence" v-if="item.noon === '03'">下午</div>
      <div class="caseSequence" v-if="item.noon === '05'">晚上</div>
     <div class="statusLabel" v-if="item.visitState === '00'">草稿</div>
      <div class="statusLabel" style="color: #1e88f6;font-weight: 400" v-if="item.visitState === '01'">待诊</div>
      <div class="statusLabel" style="color: #aab4bf;font-weight: 400" v-if="item.visitState === '02'">已诊</div>
      <div class="statusLabel" style="color: #aab4bf;font-weight: 400" v-if="item.visitState === '03'">已收</div>
      <div class="statusLabel" style="color: #aab4bf;font-weight: 400" v-if="item.visitState === '04'">已退</div>
    </div>
    <div class="loading" v-if="loading">加载中...</div>
    <div class="no-more" v-if="noMore">没有更多数据了</div>
  </div>
</div>
</template>

<script>
import {get,post} from "@/api/api";
export default {
  name: "index",
  data() {
    return {
      searchTimer: null,
      loading: false,
      noMore: false,
      pageNum: 1,
      pageSize: 100,
      userInfo:JSON.parse(sessionStorage.getItem('User')),
      search:{
        key: '',
        date: this.formatDate(new Date())
      },
      dateLabel: this.formatDateLabel(new Date()),
      active: null,
      showDatePicker: false,
      patientDraftList:[], //草稿患者列表
      patientList:[], //患者列表
      isInitializing: true, //初始化标志
      isRefreshingFromWatch: false, // 添加标志位，避免重复刷新
      lastSwitchTime: 0, // 用于节流切换
    }
  },
  mounted() {
    if (this.$store.state.patientDraftList.length !== 0) {
      this.$store.state.patientDraftList.forEach(item => {
        item.registerId = this.userInfo.id
        item.updator = this.userInfo.id
      })
    }
    let hospitalInfo = JSON.parse(sessionStorage.getItem('hospitalInfo'))
    if (hospitalInfo) {
      hospitalInfo.registerId = this.userInfo.id
      hospitalInfo.updator = this.userInfo.id
      sessionStorage.setItem('hospitalInfo', JSON.stringify(hospitalInfo))
    }

    if (this.$store.state.medicalRecordDraftList.length !== 0) {
      this.$store.state.medicalRecordDraftList.forEach(item => {
        item.registerInfo.deptID = this.userInfo.id
        item.registerInfo.registerID = this.userInfo.id
        item.registerInfo.userID = this.userInfo.id
        if (item.herbalPrescriptionInfo.length !== 0) {
          item.herbalPrescriptionInfo.forEach(item => {
            item.creator = this.userInfo.id
            item.operator = this.userInfo.id
            item.userID = this.userInfo.id
          })
        }
        if (item.medicalRecordInfo) {
          item.medicalRecordInfo.creator = this.userInfo.id
          item.medicalRecordInfo.operator = this.userInfo.id
          item.medicalRecordInfo.userID = this.userInfo.id
        }
      })
    }
    this.queryOutpatientFormList(false, null, true) // 初始化时自动选择
    this.initScrollListener()
     setTimeout(() => {
    this.resetList()
    })
  },
  beforeDestroy() {
    console.log('leftListTab beforeDestroy, cleaning up...')
    // 重置标志位，避免内存泄漏
    this.isInitializing = false;
    this.isRefreshingFromWatch = false;
    this.removeScrollListener()
  },
  watch:{
    '$store.state.nowPatientInfo':{
      handler (newVal,oldVal) {
      },
      deep:true
    },
    '$store.state.resetList':{
      handler (newVal,oldVal) {
        if (newVal) {
          this.$store.state.aiDiagnosisList = []
           if (this.$store.state.zcPatient) {
             this.activeItem(JSON.parse(JSON.stringify(this.$store.state.zcPatient)))
             this.$store.state.zcPatient = null
             this.queryOutpatientFormList(false, null, true)
           } else {
             this.resetList()
           }

        }
      },
    }
  },
  methods: {
    resetList () {
      // this.queryOutpatientFormList(false, null, true)
        if (this.$store.state.patientDraftList && this.$store.state.patientDraftList.length > 0 && this.$store.state.resetList!==2) {
          this.activeItem(this.$store.state.patientDraftList[0])
        } else if (this.patientList.length > 0 && this.$store.state.resetList!==2) {
          this.activeItem(this.patientList[0])
        } else if (this.patientList.length > 0) {
          this.activeItem(this.patientList[0])
        }else {
          // 当没有草稿和待诊患者时，清空当前选中的患者信息，避免重复激活已删除的草稿
          this.$store.state.nowPatientInfo = {}
        }
      this.$store.state.resetList = false
    },
    // 选中患者
    activeItem (patient,registerInfo) {
      console.log('pppppppppp', patient)
      const now = Date.now();
      if (now - this.lastSwitchTime < 300) return;
      this.lastSwitchTime = now;
      if (this.$store.state.aiDiagnosisList.length > 0) {
        console.log('lllllllllllll',  this.$store.state.nowRegisterInfo)
        this.$store.state.isChangeLeftListBar = true
        if (!this.$store.state.stopChange) {
          this.$store.state.zcPatient = patient
        }
        return
      }
      console.log(patient)
      this.active = patient.medicalRecordId ? patient.medicalRecordId : ((patient.id && patient.visitState !=='00') ? patient.id : patient.draftId)
      this.$store.state.nowPatientInfo = patient
      this.$store.state.nowRegisterInfo = (registerInfo && registerInfo !== undefined) ? registerInfo : null
      console.log('$$$$$$$$', this.$store.state.nowPatientInfo)
    },
    //增加新草稿
    addPatient () {
      this.search.date = this.formatDate(new Date())
      let draftId = Date.now().toString()
      let patienDraft = {
        draftId:draftId, //草稿id
        updator:this.userInfo.id,
        registerId: this.userInfo.id, //注册id
        caseNumber: null, //案例编号
        name: "匿名患者", //患者名称
        visitDate: this.$getCurrentDate(), //挂号日期
        noon: '', //午别
        address:null, //地址
        sequence: null, //序号
        visitState: "00", //诊断类型 00未诊断(草稿)
        medicalRecordId: null, //病历id
        provinceCode:null, //省份代码
        cityCode:null, //市代码
        districtCode: null, //地区代码
        gender:'NAN', //性别
        id:null, // 患者id
        idNumber:null, // 身份证号
        job:null, //职业
        marriage:null, //婚姻状况
        nationnality:null, //民族
        phoneNumber:null, //电话号
        emergencyPhone:null, //紧急联系电话
        weight:null, //体重
        height:null, //身高
        ageYear: '', // 新增，确保为字符串，避免 Element props 警告
      }
      let medicalRecordDraft = {
        draftId:draftId,
        attachmentIds:[], //附件id集
        aiResultList:[
          {
            diagnosis: '', //病症
            dialectic: '', //辨证
            therapy: '', //治法
            prescriptionMedicine: '', //方药
            constitution: '', //体质
            doctorAdvice: {
              dietaryAdviceObj:{
                dietaryAdvice:""
              },
              sleepAdviceObj:{
                sleepDietaryAdvice:"",
                sleepEnvAdvice:""
              },
              exerciseAdviceObj:{
                pmExerciseAdvice:""
              },
              teaAdviceObj:{
                teaAdvice:""
              },
              improveAdviceObj:{
                improveAdvice1:""
              }
            }, //医嘱事项
            dialecticalGovernance:'', //辨证要点
            treat: '', //处置
            prescriptionName: '诊断结果一'
          }
        ],
        herbalPrescriptionInfo:[
          {
            herbalPrescriptionInfoDraftId:Date.now().toString(), //药方草稿id
            creator:this.userInfo.id,
            userID: this.userInfo.id,
            dailyDosage: "1", //剂量
            dosage: "120", //服用量
            frequency: "YRLC", //频率
            herbalDetails: [ // 草药详情
              {
                operator:this.userInfo.id,
                herbalDetailsDraftId:Date.now().toString(), //草药服用详情id
                herbalName:null, //草药名称
                dosage: null, //用量
              }
            ],
            operator:this.userInfo.id, //操作者id
            payNumber: 1, //剂
            prescriptionName: '中药处方一', // 处方名称
            remark:null, //备注
            usageDays: null,//使用天数
            usageMode:'JF', //使用方式
          }
        ],
        medicalRecordInfo:{
          dateOfOnSet:this.$getCurrentDate(), //发病日期
          allergy: "无", // 过敏史
          auxiliaryExamination:null, // 辅助检查
          birthHistory:null, // 出生史
          caseNumber:null, // 案例编号
          creator:this.userInfo.id, //创建者
          diagnosis:null, // 诊断
          dialectic:null, // 辩证
          dialecticalGovernance:null, // 辩证论治
          doctorAdvice:null, // 医嘱
          epidemics:null, // 流行病史
          familyHistory: "无", // 家族史
          history: null, // 既往史
          takenMedications: "无", //曾服用药
          observationDiagnosis:null, // 望闻切诊-改为 面诊
          operator:this.userInfo.id, //操作者id
          oralExamination:null, // 口腔检查
          personalHistory: "无", // 个人史
          physique: null, // 体格检查-已弃用
          prescriptionMedicine: null, // 方药
          present: null, // 现病史-改为病程
          prognosis: null, // 预后
          readme: null, // 主诉
          target: null, // 目标
          therapy: null, // 治法
          treat: null, // 处置
          constitution:null,
          coldAndHeat:null, //寒热-新增
          diet:"纳可", //饮食-新增
          sweating:null, //汗出-新增
          urinate:"小便正常", //小便-新增
          stool:"大便正常", //大便-新增
          period:"经期正常", //经期-新增
          weight:null, //体重-新增
          height:null, //身高-新增
          bodyTemperature:null, //体温-新增
          pulseRate:null, //脉搏-新增
          breathing:null, //呼吸-新增
          bloodPressure:null, //血压-新增
          bloodOxygen:null, //血氧-新增
          bloodGlucose:null, //血糖-新增
          tongueDiagnosis:null, //舌诊-新增
          pulseDiagnosis:null, //脉诊-新增
          mainSymptoms:null, //主症-新增
          sleepChronicles:"眠可", //睡眠-新增
          emotion:"情绪正常", //情志-新增
          presentOther: null, //其他-新增
          chinesePatentMedicine:null, //中成药
        },
        registerInfo:{
          initialDiagnosis:1,
          userID:this.userInfo.id,
          deptID:this.userInfo.id,
          registerID:this.userInfo.id,
          caseNumber:null, //案例编号
          noon: this.getNoonValue(), //午别
          visitDate: this.$getCurrentDate(), //挂号日期
          visitState:'00'
        }
      }
      this.$store.commit('addPatientDraft',patienDraft)
      this.$store.commit('addMedicalRecordDraft',medicalRecordDraft)
      this.resetList()
      },
    //分页查询患者列表
    queryOutpatientFormList (isLoadMore = false, patient, autoSelect = true, noreset) {
      // 如果正在加载或者是加载更多但已经没有更多数据，则直接返回
      if (this.loading || (isLoadMore && this.noMore)) {
        return;
      }

      // 如果是加载更多，先增加页码
      if (isLoadMore) {
        this.pageNum++;
      }

      this.loading = true;
      post('/outpatientDoctor/register/queryOutpatientFormList', {
        key: this.search.key,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        visitDate: this.search.key ? null : this.search.date
      }).then(res => {
        let data = res.data.data
        const list = data.list || []

        // 将列表颠倒排序，最新的患者显示在前面
        // const reversedList = [...list].reverse()
        const reversedList = [...list]
        if (isLoadMore) {
          this.patientList = [...this.patientList, ...reversedList]
        } else {
          this.patientList = reversedList
        }

        // 判断是否还有更多数据
        this.noMore = list.length < this.pageSize

        // 如果没有数据且是加载更多，回退页码
        if (list.length === 0 && isLoadMore) {
          this.pageNum--;
        }
        if (patient) {
          console.log('papapapapapa', patient)
          this.activeItem(patient)
        } else {
          if (!noreset && noreset !== 'noreset') {
            // 如果是自动选择，选中第一个患者
            this.resetList()
          } else if(this.$store.state.activeFirst) {
            this.activeItem(this.patientList[0])
            this.$store.state.activeFirst = false
          }
        }
      }).catch(error => {
        console.error('查询患者列表失败:', error);
        // 即使接口调用失败，也需要重置标志位
        this.isRefreshingFromWatch = false;
        this.isInitializing = false;
      }).finally(() => {
        this.loading = false
        this.isRefreshingFromWatch = false; // 重置标志位
        this.isInitializing = false; // 初始化完成
      })
    },
    // 格式化日期为YYYY-MM-DD格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      console.log('yyyyyyyyyy',year + '-' + month + '-' + day)
      return `${year}-${month}-${day}`;
    },
    // 格式化日期标签为MM-DD格式，如果是今天则显示"今天"
    formatDateLabel(date) {
      // 判断是否为今天
      const today = new Date();
      const isToday = date.getDate() === today.getDate() &&
                     date.getMonth() === today.getMonth() &&
                     date.getFullYear() === today.getFullYear();

      if (isToday) {
        return "今天";
      } else {
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${month}-${day}`;
      }
    },
    // 处理日期变化事件
    handleDateChange(val) {
      if (val) {
        console.log(val)
        this.dateLabel = this.formatDateLabel(new Date(val));
        this.showDatePicker = false;
        this.pageNum = 1;
        this.noMore = false;
        this.queryOutpatientFormList();
      }
    },
    handleSearch() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        this.pageNum = 1;
        this.noMore = false;
        this.queryOutpatientFormList();
      }, 300);
    },
    initScrollListener() {
      const listBox = this.$el.querySelector('.listBox');
      if (listBox) {
        listBox.addEventListener('scroll', this.handleScroll);
      }
    },
    removeScrollListener() {
      const listBox = this.$el.querySelector('.listBox');
      if (listBox) {
        listBox.removeEventListener('scroll', this.handleScroll);
      }
    },
    handleScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      // 距离底部20px时触发加载
      if (scrollHeight - scrollTop - clientHeight < 20 && !this.loading && !this.noMore) {
        this.queryOutpatientFormList(true);
      }
    },
    //获取午别
    getNoonValue() {
      const currentHour = new Date().getHours();

      if (currentHour >= 0 && currentHour < 12) {
        return '01'; // 上午（0:00-11:59）
      } else if (currentHour >= 12 && currentHour < 18) {
        return '03'; // 下午（12:00-17:59）
      } else {
        return '05'; // 晚上（18:00-23:59）
      }
    }
  }
}
</script>

<style lang="less" scoped>
.leftListTab{
  height: 100%;
  width: 100%;
  background-color: #fff;
  border-right:1px solid #eaedf1;
  overflow: hidden;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  .searchBox{
    display: flex;
    align-items: center;
    gap: 10px;
    height: 55px;
    border-bottom:1px solid #eaedf1;
    justify-content: space-around;
    padding: 0 10px;
    .search{
     /deep/ .el-input__inner{
        height: 32px;
       line-height: 32px;
      }
      /deep/ .el-input__icon{
        line-height: 32px;
      }
    }
    .deliveringBtn:hover{
      background-color: #23cf67;
    }
    .deliveringBtn:active{
      background-color: #08a446;
    }
    .deliveringBtn{
      height: 32px;
      width: 71.6px;
      min-width: 62px;
      background-color: #1ec761;
      border-radius: 6px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      user-select: none;
      font-size: 14px;
      span{
        font-size: 25px;
        letter-spacing: 3px;
        font-weight: 200;
        padding-top: 2px;
      }

    }
    .deliveringBtnNot{
      height: 32px;
      width: 71.6px;
      background-color: rgba(253, 253, 253, 0.91);
      border-radius: 6px;
      color: rgba(225, 225, 225, 0.91);
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid;
      user-select: none;
      span{
        font-size: 25px;
        letter-spacing: 3px;
        font-weight: 200;
        padding-top: 2px;
      }
    }
  }
  .listTabBox{
    height: 41px;
    width: 100%;
    border-bottom:1px solid #eaedf1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tabBox{
      margin-left: 10px;
      .tabItem{
        color: #000;
        font-weight: 700;
        span{
          font-size: 13px;
          color: red;
          margin-left: 5px;
        }
      }
    }
    .select{
      margin-right: 10px;
      width: 70px;
      height: 35px;
      //border: 1px solid red;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .dateLabel{
        position: absolute;
        color: #7a8794;
        user-select: none;
        i{
          margin-left: 5px;
        }
      }
      .pickerBox{
        opacity: 0;
        /deep/  .el-date-editor.el-input, .el-date-editor.el-input__inner{
          width: 70px;
          cursor: pointer;
        }
        /deep/ .el-input--prefix .el-input__inner{
          cursor: pointer;
        }
      }
    }
  }
  //&::-webkit-scrollbar-track {
  //  background-color: transparent;
  //}
  .listBox{
    //flex: 1;
    //border: 1px solid red;
    padding: 10px 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    height: calc(100vh - 280px);
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 7px;
      background-color: transparent;
    }

    //&:hover::-webkit-scrollbar {
    //  width: 8px;
    //  background-color: rgb(230, 234, 237);
    //}

    &:hover::-webkit-scrollbar-thumb {
      background-color: rgb(230, 234, 237);
      border-radius: 3px;
    }

    .itemBox{
      height: 44px;
      width: 100%;
      border-radius: 8px;
      background-color: var(--primary-color2);
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-shrink: 0;
      color: var(--sideMenun-text-color);
      cursor: pointer;
      user-select: none;
      font-size: 12px;
      border: 1px solid var(--primary-color);
      transition: all 0.3s ease;
      font-weight: 500;
      .userInfo{
        display: flex;
        align-items: center;
        gap: 5px;
        margin-left: 10px;
        .userImg{
          display: flex;
          align-items: center;
          justify-content: center;
          height: 30px;
          width: 30px;
          border-radius: 6px;
          background-color: #fff;
          border: 1px solid #eff3f6;
          i{
            font-size: 18px;
            color: #5199f8;
          }
        }
        .userName{
          width: 70px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .caseSequence{
        color: #000;
        font-weight: 700;
        font-size: 12px;
        margin-left: 0.5vw;
      }
      .statusLabel{
        font-size: 12px;
        font-weight: 700;
        color: var(--sideMenun-text-color);
        margin-right: 5px;
      }
    }
    .itemBoxActive{
      height: 44px;
      width: 100%;
      border-radius: 8px;
      background: var(--primary-color);
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-shrink: 0;
      color: #fff;
      cursor: pointer;
      user-select: none;
      font-size: 12px;
      box-shadow: 0 1px 5px var(--primary-color);
      .userInfo{
        display: flex;
        align-items: center;
        gap: 5px;
        margin-left: 10px;
        .userImg{
          display: flex;
          align-items: center;
          justify-content: center;
          height: 30px;
          width: 30px;
          border-radius: 6px;
          background-color: #fff;
          border: 1px solid #eff3f6;
          i{
            font-size: 18px;
            color: #5199f8;
          }
        }
        .userName{
          width: 70px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .caseSequence{
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        margin-left: 0.5vw;
      }
      .statusLabel{
        font-weight: 700;
        color: #fff !important;
        margin-right: 5px;
      }
    }
    .nothing, .loading, .no-more {
      color: #aab4bf;
      font-size: 11px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      width: 100%;
    }
  }
}
/deep/ .el-input__suffix {
  display: none;
}
</style>
